import PropTypes from 'prop-types'

const SHAHADA = 'لا إله إلا الله'

const FlagAR = ({ width = '20', height = '20', className = '', ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 60 40"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="60" height="40" fill="#006C35" />
    <text
      x="30"
      y="18"
      textAnchor="middle"
      fill="#FFFFFF"
      fontSize="7"
      fontFamily="serif"
    >
      {SHAHADA}
    </text>
    <path
      d="M18,26 Q30,22 42,26"
      stroke="#FFFFFF"
      strokeWidth="1.5"
      fill="none"
      strokeLinecap="round"
    />
    <line x1="18" y1="26" x2="42" y2="26" stroke="#FFFFFF" strokeWidth="1" />
  </svg>
)

FlagAR.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
}

export default FlagAR
